import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, mergeMap, of } from 'rxjs';

import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { ROUTES } from '../constants/routes.constants';

export const NON_AUTHENTICATED_GUARD = (
  route: ActivatedRouteSnapshot,
  next: RouterStateSnapshot
): Observable<UrlTree | boolean | UrlTree> | boolean => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return authFacade.accessToken$.pipe(
    mergeMap(accessToken => {
      const { accessTokenId } = route.queryParams || {};
      if (accessTokenId && next.url.toString().startsWith(ROUTES.login)) {
        return of(true);
      }

      if (accessToken) {
        return of(router.createUrlTree([ROUTES.home]));
      }
      return of(true);
    })
  );
};
